import React from 'react'
import {
    StyledCardTakeover,
    StyledCardTakeoverImg,
    StyledCardTakeoverLink,
    StyledCardTakeoverPicture,
} from '../../cards/CardTakeover/CardTakeover.styled'

interface CardTakeoverProps {
    imageSrc: string
    imageAlt: string
    linkUrl: string
    backgroundColor?: string
    cardNumber: number
}

// TODO Takeover card should have card.clicked?
export const CardTakeover: React.FC<CardTakeoverProps> = (props) => {
    const { imageSrc, imageAlt, linkUrl, backgroundColor } = props
    return (
        <StyledCardTakeover backgroundColor={backgroundColor}>
            <StyledCardTakeoverLink to={linkUrl}>
                <StyledCardTakeoverPicture>
                    <StyledCardTakeoverImg src={imageSrc} alt={imageAlt} />
                </StyledCardTakeoverPicture>
            </StyledCardTakeoverLink>
        </StyledCardTakeover>
        // Safe link
    )
}
